var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RatioBox',{attrs:{"ratio":_vm.ratio}},[_c('div',{staticClass:"v-full",staticStyle:{"position":"relative"}},[_vm._t("default"),_c('Empty',{staticClass:"empty-assets",attrs:{"image":_vm.emptyAssets,"description":_vm.description}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }